import type { WorkoutSet } from "../../../shared/src";
import { ExerciseCard } from "./ExerciseCard";

interface AdHocExerciseCardProps {
  workoutId: number;
  exerciseId: number;
  exerciseName: string;
  sets: WorkoutSet[];
  onSetAdded: (exerciseId: number) => void;
  onRemove: () => void;
  disabled: boolean;
}

export function AdHocExerciseCard({
  workoutId,
  exerciseId,
  exerciseName,
  sets,
  onSetAdded,
  onRemove,
  disabled,
}: AdHocExerciseCardProps) {
  return (
    <div className="relative">
      <ExerciseCard
        workoutId={workoutId}
        exerciseId={exerciseId}
        exerciseName={exerciseName}
        sets={sets}
        disabled={disabled}
        onSetAdded={onSetAdded}
      />
      <button
        type="button"
        onClick={onRemove}
        disabled={disabled}
        aria-label={`remove ${exerciseName} from workout`}
        className="absolute right-2 top-2 rounded-md border border-red-900 px-2 py-1 text-xs text-red-300 hover:bg-red-950 disabled:opacity-30"
      >
        Remove
      </button>
    </div>
  );
}
